export class Page<T> {
    public continuationToken: string;
    public hasMoreItems: boolean;
    public items: Array<T>;
}
